import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Award, BookOpen, TrendingUp } from 'lucide-react';
import HeroSlider from '../components/HeroSlider';

const Home = () => {
  useEffect(() => {
    document.title = 'akarma - Eğitim ve Koçluk Hizmetleri | Banu Gökcül';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Akarma, Türk iş dünyasının ihtiyaçlarını karşılamaya yönelik uluslararası standartlar içeren eğitim, ölçme-değerlendirme ve yönetim geliştirme hizmetleri sunmaktadır.');
    }
  }, []);

  const services = [
    {
      title: 'Koçluk Seansları',
      description: 'Koçluk seansları, derin kişisel sorunların birebir çözülmesi için NLP ile hızlı dönüşümsel terapi görüşmeleridir.',
      icon: Users,
      link: '/hizmetler#coaching'
    },
    {
      title: 'Kurumsal Eğitimler',
      description: 'Kurumsal firmaların yönetici ve çalışanları için hazırlanmış eğitimlerdir.',
      icon: Award,
      link: '/kurumsal-egitimler'
    },
    {
      title: 'Motivasyon Konuşmaları',
      description: 'Kurumlara özel vizyon geliştiren, ilham veren, motive eden, duygusal çeviklik kazandıran motivasyon konuşmaları sunar.',
      icon: TrendingUp,
      link: '/hizmetler#motivation'
    }
  ];

  const stats = [
    { number: '5000+', label: 'Bireysel Danışan' },
    { number: '500+', label: 'Kurumsal Danışma' },
    { number: '1000+', label: 'Motivasyon Konuşmaları' },
    { number: '20000+', label: 'Toplam Eğitim Süresi (saat)' }
  ];

  const clients = [
    '/images/clients/1.png', '/images/clients/2.png', '/images/clients/3.png',
    '/images/clients/4.png', '/images/clients/5.png', '/images/clients/6.png',
    '/images/clients/7.png', '/images/clients/8.png', '/images/clients/9.png',
    '/images/clients/10.png', '/images/clients/11.png', '/images/clients/12.png'
  ];

  return (
    <div className="home">
      {/* Hero Slider */}
      <HeroSlider />

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 section-title">Hizmetlerimiz</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Banu Gökcül, kurucusu olduğu Akarma Eğitim ve koçluk hizmetleri bünyesinde 
              eğitimler, seminerler, koçluk, mentorluk ve motivasyon konuşmaları hizmeti verir.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-2xl shadow-lg card-hover"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-xl flex items-center justify-center mb-6">
                    <Icon size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-akarma-blue font-semibold hover:text-purple-600 transition-colors"
                  >
                    Daha Fazla Bilgi
                    <ArrowRight size={18} className="ml-2" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold mb-2">{stat.number}</div>
                <div className="text-lg opacity-90">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="slide-in-left">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 section-title">
                Davranış Bilimleri Uzmanı<br />Banu GÖKCÜL, PhD
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                14 yıl Bilgi Üniversitesinde ve şimdi Bahçeşehir Üniversitesi Executive MBA Programında, 
                liderlik ve yönetim becerileri konusunda ders vermekte olan Gökcül, 21 yıl önce kurucusu 
                olduğu Akarma Eğitim ve Danışmanlık Merkezinde, eğitimlerin yanı sıra bireysel ve 
                kurumsal koçluk uygulamaları ile edinmiş olduğu deneyim ve bilgilerini ihtiyacı olan 
                kişilerle ve kuruluşlara aktarmaktadır.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Gökcül, aynı zamanda motivasyon konuşmacısı olarak farklı sektörlerden yüzlerce kuruma 
                pek çok kez konuşmacı olarak katılmıştır. Türkiye'ye NLP tekniğini ilk getirenlerdendir.
              </p>
              <Link
                to="/hakkinda"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
              >
                Daha Fazlasını Öğrenin
                <ArrowRight size={20} className="ml-2" />
              </Link>
            </div>
            <div className="slide-in-right">
              <div className="relative">
                <img
                  src="https://akarma.com.tr/upload/akarma/ser1.jpg"
                  alt="Banu Gökcül"
                  className="rounded-2xl shadow-2xl w-full"
                />
                <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl">
                  <div className="flex items-center space-x-3">
                    <BookOpen size={40} className="text-akarma-blue" />
                    <div>
                      <div className="text-3xl font-bold text-akarma-blue">4</div>
                      <div className="text-sm text-gray-600">Yayınlanmış Kitap</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Books Preview */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 section-title">Kitaplar</h2>
            <p className="text-xl text-gray-600">Liderlik Kitapları Serisi - Alfa ve Kapital Yayıncılık</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-lg card-hover text-center">
              <img
                src="https://akarma.com.tr/images/super-beynin-sirlari-banu-gokcul.jpg"
                alt="Süper Beynin Sırları"
                className="w-full h-80 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold mb-2">Süper Beynin Sırları</h3>
              <p className="text-gray-600 text-sm mb-4">2019</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg card-hover text-center">
              <img
                src="https://akarma.com.tr/images/stratejik-iliski-kurma-banu-gokcul-kitap.jpg"
                alt="Stratejik İlişki Kurma"
                className="w-full h-80 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold mb-2">Stratejik İlişki Kurma</h3>
              <p className="text-gray-600 text-sm mb-4">Müzakere - 2015</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg card-hover text-center">
              <img
                src="https://akarma.com.tr/images/gozler-uzerindeyken-basarmak-sunum-banu-gokcul.jpg"
                alt="Gözler Üzerindeyken Başarmak"
                className="w-full h-80 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold mb-2">Gözler Üzerindeyken Başarmak</h3>
              <p className="text-gray-600 text-sm mb-4">Sunum - 2012</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-lg card-hover text-center">
              <img
                src="https://akarma.com.tr/images/farkindaligin-sifresi-banu-gokcul.jpg"
                alt="Farkındalığın Şifresi"
                className="w-full h-80 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold mb-2">Farkındalığın Şifresi</h3>
              <p className="text-gray-600 text-sm mb-4">2009</p>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/kitaplar"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
            >
              Tüm Kitapları Gör
              <ArrowRight size={20} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section className="py-20 bg-gradient-to-r from-akarma-blue-700 to-akarma-blue">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="text-6xl mb-6">“</div>
            <p className="text-2xl md:text-3xl font-light mb-8 leading-relaxed">
              Karşılaştığınız önemli problemler, onları yaratan düşünce tarzları ile çözülemez.
            </p>
            <div className="text-xl font-semibold">Albert Einstein</div>
            <div className="text-lg opacity-90">Teorik Fizikçi</div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 section-title">Referanslarımız</h2>
            <p className="text-xl text-gray-600">Bize Güvenen Bazı Firmalar</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clients.map((client, index) => (
              <div key={index} className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all duration-300">
                <img
                  src={`https://akarma.com.tr${client}`}
                  alt={`Client ${index + 1}`}
                  className="max-w-full h-auto"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Hemen Başlayalım</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Kendinizi geliştirmek, kariyerinizi ilerletmek veya kurumunuz için eğitim almak mı istiyorsunuz? 
            Hemen iletişime geçin!
          </p>
          <Link
            to="/iletisim"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-lg"
          >
            İletişime Geçin
            <ArrowRight size={24} className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;